module.exports = __webpack_public_path__ + "img/certificate.96e99cb6.webp";